import * as React from 'react';

import { ILink } from '../../types';
import { ITargetCheckRun } from 'src/services/api/link/targetCheck/id';
import API from 'src/services/api';

const { useState, useEffect } = React;

export const useRunCheck = (link: ILink, onRun: (link: ILink) => void) => {
  const [isRunning, setRunning] = useState(false);
  const [runOutcome, setRunOutcome] = useState<ITargetCheckRun>({
    status: '',
    displayMessage: '',
  });

  useEffect(() => {
    const { getData, cancel } = API.LINK.TARGET_CHECK.id(link.createdLinkId);
    async function fetch() {
      if (!isRunning) {
        return;
      }
      const data = await getData();
      setRunning(false);
      setRunOutcome(data);
      onRun({
        ...link,
        ...data,
      });
    }
    fetch();
    return cancel;
  }, [isRunning]);

  const runCheck = () => setRunning(true);

  return {
    isRunning,
    runCheck,
    runOutcome,
  };
};



// WEBPACK FOOTER //
// ./src/views/TargetCheck/components/TargetCheck/useRunCheck.ts